"use client";

import { usePathname } from "next/navigation";
import { NEVER_PREFIXED } from "./localePath";
import { PREFIXED_LOCALES } from "./translations";

/**
 * The path as the browser shows it. Since 25.10.2026 every page lives under
 * app/[lang] and the proxy rewrites German URLs to /de/… internally, so a page
 * prerendered for German sees "/de/preise" while the visitor's URL is
 * "/preise". The legal pages are never prefixed in the browser either, but are
 * rendered as /en/impressum etc. for an English visitor. Other prefixed
 * languages (/en/preise) are the same on both sides. Components that compare
 * or rebuild the path (language switcher, dock lists, nav state) use this
 * instead of usePathname(), so server HTML and hydration agree.
 */
export function toSitePath(pathname: string): string {
  if (pathname === "/de") return "/";
  if (pathname.startsWith("/de/")) return pathname.slice(3);
  const prefix = PREFIXED_LOCALES.find((l) => pathname.startsWith(`/${l}/`));
  if (prefix) {
    const rest = pathname.slice(prefix.length + 1);
    if (NEVER_PREFIXED.some((p) => rest === p || rest.startsWith(`${p}/`))) return rest;
  }
  return pathname;
}

export function useSitePathname(): string {
  return toSitePath(usePathname() ?? "/");
}
